import { AppInterface } from "types/types"
import useT from "utils/useT"
import Spinner from "components/Spinner"
import Post from "./Post"
import { Virtuoso } from "react-virtuoso"

interface Props {
  apps?: AppInterface[]
  isPending?: boolean
  endReached?: () => void
}

const FeedList = ({ apps, isPending, endReached }: Props) => {
  const t = useT()

  if (!apps || apps.length === 0) {
    return (
      <div className="content mb-0 mt-2">
        <div className="d-flex justify-content-center p-5">{t.emptyList}</div>
      </div>
    )
  }

  return (
    <div className="content mb-0 mt-2">
      <Virtuoso
        useWindowScroll
        data={apps}
        endReached={endReached}
        overscan={2000}
        itemContent={(index, app) => <Post app={app} index={index} />}
        components={{
          Footer: () =>
            isPending ? (
              <div className="d-flex justify-content-center mb-3">
                <Spinner size={60} />
              </div>
            ) : null,
        }}
      />
    </div>
  )
}

export default FeedList
